import { Box, Container, CssBaseline } from '@mui/material';
import { Copyright } from '../../Helpers/utils';

/**
 * Shared layout wrapper for public-facing auth pages (Login, ForgotPassword,
 * ResetPassword, SetPassword, etc.).
 *
 * Behaviour:
 * - Page always fills at least the full viewport height (no short pages).
 * - Content is centred in the available space above the footer.
 * - The Copyright footer is always rendered once, pinned to the bottom of the
 *   viewport on short pages and pushed below the content on tall pages (never
 *   overlapping, never duplicated).
 *
 * Usage:
 *   <PageLayout maxWidth="xs">
 *     {your page content — do NOT include <Copyright> inside}
 *   </PageLayout>
 */
export default function PageLayout({ children, maxWidth = 'xs' }) {
  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        {/* Main content grows to fill available space */}
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Container component="div" maxWidth={maxWidth}>
            {children}
          </Container>
        </Box>

        {/* Footer — always at bottom, never duplicated */}
        <Box component="footer">
          <Container maxWidth={maxWidth}>
            <Copyright sx={{ py: 3 }} />
          </Container>
        </Box>
      </Box>
    </>
  );
}
